import _extends from "@babel/runtime/helpers/extends";
var _AlertIcon;
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { SENSATION_WHITE } from '../colors';
import { SHADOW_FOCUSED } from '../shadows';
import Flex from '../Flex';
import { Base } from '../Typography';
import SvgIcon from '../SvgIcon';
import { ICON_SIZE } from '../constants';
import AlertIcon from '@tourlane/iconography/Glyphs/Other/Alert';
import IconButton from '../Button/IconButton';
import { NOTIFICATION_DELAY, NOTIFICATION_MARGIN } from './constants';
import { getVariantColor } from '../helpers/variants';
import { top } from '../style/top';
import { marginBottom } from '../style/margin-bottom';
import { marginTop } from '../style/margin-top';
const Wrapper = styled.div`
  position: relative;
  ${({
  $pointer
}) => $pointer && `cursor: pointer;`}
`;
const Container = styled(Base)`
  display: inline-flex;
  pointer-events: all;
  background-color: ${SENSATION_WHITE};
  box-shadow: ${SHADOW_FOCUSED};
  padding: 6px 16px;
  border-radius: 24px;
  ${({
  $position
}) => $position === 'top' && marginBottom(NOTIFICATION_MARGIN)}
  ${({
  $position
}) => $position === 'bottom' && marginTop(NOTIFICATION_MARGIN)}
`;
const MessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ActionContainer = styled.div`
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledLeftIcon = styled(SvgIcon)`
  margin-right: 12px;
`;
const StyledLeftEmoji = styled.div`
  margin-right: 12px;
  position: relative;
  ${top({
  xs: '1px',
  xl: '2px'
})}
`;
const Notification = ({
  pointer = false,
  position,
  action,
  message,
  icon,
  emoji,
  variant = 'default',
  delay = NOTIFICATION_DELAY,
  onClose,
  onAutoClose,
  className,
  style,
  closeButtonLabel = 'Close',
  closeButtonProps = {},
  ...otherProps
}) => {
  // if action is undefined, show default action
  const DefaultAction = onClose ? /*#__PURE__*/React.createElement(IconButton, _extends({
    tabIndex: -1,
    hasClose: true,
    onClick: onClose,
    "aria-label": closeButtonLabel
  }, closeButtonProps)) : null;
  const Action = action === undefined ? DefaultAction : action;
  // customize icon element depending on 'icon' and 'variant' props
  const Icon = icon === undefined && (variant === 'error' || variant === 'alert') ? _AlertIcon || (_AlertIcon = /*#__PURE__*/React.createElement(AlertIcon, null)) : icon;

  // customize message element depending on icon
  const Message = Icon ? /*#__PURE__*/React.createElement(Flex, {
    direction: "ltr",
    center: true
  }, /*#__PURE__*/React.createElement(StyledLeftIcon, {
    size: ICON_SIZE,
    color: getVariantColor(variant)
  }, Icon), /*#__PURE__*/React.createElement("div", null, message)) : emoji ? /*#__PURE__*/React.createElement(Flex, {
    direction: "ltr",
    center: true
  }, /*#__PURE__*/React.createElement(StyledLeftEmoji, null, emoji), /*#__PURE__*/React.createElement("div", null, message)) : /*#__PURE__*/React.createElement("div", null, message);

  // set timer to call onAutoClose when delay passes
  useEffect(() => {
    if (!delay) {
      return;
    }
    const timeoutId = setTimeout(() => {
      onAutoClose?.();
    }, delay);
    return () => clearTimeout(timeoutId);
  }, [delay]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    style: style,
    $pointer: pointer
  }, /*#__PURE__*/React.createElement(Container, _extends({
    $position: position,
    as: 'div'
  }, otherProps), /*#__PURE__*/React.createElement(MessageContainer, null, Message), Action ? /*#__PURE__*/React.createElement(ActionContainer, null, Action) : null));
};
export default Notification;